import withStyles from '@material-ui/core/styles/withStyles'
import { CircularProgress } from '@material-ui/core'
import theme from 'styles/theme'

export const ColorCircularProgress = withStyles({
  root: {
    color: theme.colors.mainOrange,
  },
})(CircularProgress)
